import general from '../utils/general';

export default {
  /**
   * Reverse string
   * @param {string} str - String you want to reverse
   * @returns {string} Reverse of str
   * @example
   * // returns "olleh"
   * imkt.utils.string.reverse("hello")
   */
  reverse(str: string) {
    if (typeof str !== "string") {
      return "";
    }

    if (str.trim() === "") {
      return str;
    }

    return str.split("").reverse().join("");
  },
};

export const replaceText = (srcObj: any, inputText: string, replaceMap: any) =>
  Object.keys(replaceMap).reduce(
    (outputText, replaceKey) =>
      srcObj[replaceKey]
        ? outputText.replace(`{{${replaceKey}}}`, srcObj[replaceKey])
        : outputText,
    inputText
  );

export const getStrWithCommas = (input: any) =>
  general.numberWithCommas(input.toString());
